module.exports = __webpack_public_path__ + "static/media/faqBalance-es-tl.fc7930df.vtt";